//Parroquia Yaracuy
const munArístidesBastidas = ['Arístides Bastidas'];
const munBolívarYaracuy = ['Bolívar'];
const munBruzual = ['Bruzual', 'Campo Elías'];
const munCocorote = ['Cocorote'];
const munIndependenciaYaracuy = ['Independencia'];
const munJoséAntonioPáez = ['José Antonio Páez'];
const munLaTrinidad = ['La Trinidad'];
const munManuelMonge = ['Manuel Monge'];
const munNirgua = ['Capital Nirgua', 'Salom', 'Temerla'];
const munPeña = ['Capital Peña', 'San Andrés'];
const munSanFelipe = ['Capital San Felipe', 'Albarico', 'San Javier'];
const munSucreYaracuy = ['Sucre'];
const munUrachiche = ['Urachiche'];
const munVeroes = ['Capital Veroes', 'El Guayabo'];

export const esYaracuy = [
  {
    municipio: 'Arístides Bastidas',
    parroquias: munArístidesBastidas,
  },
  {
    municipio: 'Bolívar',
    parroquias: munBolívarYaracuy,
  },
  {
    municipio: 'Bruzual',
    parroquias: munBruzual,
  },
  {
    municipio: 'Cocorote',
    parroquias: munCocorote,
  },
  {
    municipio: 'Independencia',
    parroquias: munIndependenciaYaracuy,
  },
  {
    municipio: 'José Antonio Páez',
    parroquias: munJoséAntonioPáez,
  },
  {
    municipio: 'La Trinidad',
    parroquias: munLaTrinidad,
  },
  {
    municipio: 'Manuel Monge',
    parroquias: munManuelMonge,
  },
  {
    municipio: 'Nirgua',
    parroquias: munNirgua,
  },
  {
    municipio: 'Peña',
    parroquias: munPeña,
  },
  {
    municipio: 'San Felipe',
    parroquias: munSanFelipe,
  },
  {
    municipio: 'Sucre Yaracuy',
    parroquias: munSucreYaracuy,
  },
  {
    municipio: 'Urachiche',
    parroquias: munUrachiche,
  },
  {
    municipio: 'Veroes',
    parroquias: munVeroes,
  },
];
